import React from 'react';

import Layout from '@g4/boneyard/lib/Layout'; //'../../../Layout/Layout';
import VerticalSpacing from '@g4/boneyard/lib/VerticalSpacing';
import LoadingBlock from '../LoadingBlock';

const { Row, Col } = Layout;

/** @visibleName Generic Loading Grid */
const GenericLoadingGrid = () => (
  <div>
    <Row>
      <Col span={18}>
        <LoadingBlock />
        <VerticalSpacing size={1} />
      </Col>
    </Row>
    <Row gutter={10}>
      <Col span={8}>
        <LoadingBlock />
        <VerticalSpacing size={1} />
      </Col>
      <Col span={4}>
        <LoadingBlock />
        <VerticalSpacing size={1} />
      </Col>
      <Col span={12}>
        <LoadingBlock />
        <VerticalSpacing size={1} />
      </Col>
    </Row>
    <Row gutter={10}>
      <Col span={4}>
        <LoadingBlock />
        <VerticalSpacing size={1} />
      </Col>
      <Col span={16}>
        <LoadingBlock />
        <VerticalSpacing size={1} />
      </Col>
    </Row>
    <Row>
      <Col span={6}>
        <LoadingBlock />
      </Col>
    </Row>
  </div>
);

export default GenericLoadingGrid;
